import { usePool, useUserSaleTier } from '@trustpad/launchpad';

import { tpadLogoImg } from 'assets';
import * as React from 'react';
import { NFTSaleSection } from 'src/features/pools/components/PoolSecondaryBlock/NFTSaleSection';
import { PoolInventory } from 'src/features/pools/components/PoolSecondaryBlock/PoolInventory';

import { NftPoolConfig } from '~/features/pools/types';
import { StandardCard } from '~common/UI';

import { DistributionTabs } from '../Distribution';
import { Header } from './Header';
import { PriceSection } from './PriceSection';
import { SaleSection } from './SaleSection';
import { TokenSection } from './TokenSection';

export function PoolSecondaryBlock() {
  const { pool } = usePool<NftPoolConfig>();
  const { token, description, social, sale, fundToken } = pool;
  const {
    userState: { balance },
  } = useUserSaleTier();

  return (
    <StandardCard cardClassName="overflow-hidden relative bg-dark1 bg-opacity-80 rounded-lg shadow-lg border-0 z-10">
      {false && (
        <div className="absolute z-0 transform scale-125 top-2 bottom-0 -left-80 -right-80 opacity-50">
          <img src={tpadLogoImg.src} className="opacity-5" alt="Bg" />
        </div>
      )}

      <div className="md:p-3 z-10 space-y-8">
        <Header
          token={token}
          description={description}
          social={social}
          launchProtected={
            sale.isProtected &&
            (!sale.startDate ||
              Date.parse(sale.startDate) >=
                Date.parse('2024-01-29T00:00:00.000Z'))
          }
        />

        {pool.isNft ? <NFTSaleSection /> : <SaleSection />}

        {pool.isNft ? null : <PriceSection />}

        {pool.isNft ? null : <TokenSection />}

        {pool.isNft && <PoolInventory sale={sale} fundToken={fundToken} />}

        {pool.distribution && (
          <DistributionTabs
            distribution={pool.distribution}
            token={pool.token}
            poolBalance={balance}
          />
        )}
      </div>
    </StandardCard>
  );
}
